module.exports = __webpack_public_path__ + "static/img/jianshiTitle.3227e77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/jianshiTitle.png
// module id = o+3c
// module chunks = 0